import { apiClient } from "./apiClient";
import axios from "axios";
import { API_URL } from "../config";

export async function getMe(accessToken) {
  const res = await apiClient.get("/auth/me", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

export async function refreshAccess() {
  const res = await axios.post(`${API_URL}/auth/refresh`, null, {
    withCredentials: true,
  });
  return res.data;
}

export async function logoutApi() {
  const res = await axios.post(`${API_URL}/auth/logout`, null, {
    withCredentials: true,
  });
  return res.data;
}

export async function changePasswordRequired(accessToken, payload) {
  const res = await apiClient.post("/auth/change-password-required", payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

//Backend checkler için auth/me çağıracağız.2 yerde kullanılacak login sonrası giriş oldu mu  ve uygulama açılınca kullanıcı hala login mi .me ve refresh çağrıları tek yerde toplandı
